import { useTranslation } from "react-i18next";

const VirtualCartBox = ({finalCartItems}) => {
    const { t } = useTranslation();
    const formatter = new Intl.NumberFormat('de-DE', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <div className="hidden sm:flex divide-x-2 divide-gray-dark1 divide-dashed sm:h-20 justify-end text-xs md:text-sm lg:text-base"> 
            <div></div>
            <div className="px-1.5 lg:px-3 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('no. of items')}</h1>
                <div className="font-bold">{finalCartItems.itemsCount}</div>
            </div>
            <div className="px-1.5 lg:px-3 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('total quantity')}</h1>
                <div className="font-bold">{finalCartItems.totalQuantity ? formatter.format(finalCartItems.totalQuantity) : formatter.format(0)}</div>
            </div>
            <div className="px-1.5 lg:px-3 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('net amount')}</h1>
                <div className="font-bold">{finalCartItems.netAmount ? formatter.format(finalCartItems.netAmount) : formatter.format(0)} €</div>
            </div>
            <div className="px-1.5 lg:px-3 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('extra taxes')}</h1>
                <div className="font-bold">{finalCartItems.totalTaxes ? formatter.format(finalCartItems.totalTaxes) : formatter.format(0)} €</div>
            </div>
            <div className="px-1.5 lg:px-3 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('total')} <span className="uppercase">{t('vat')}</span></h1>
                <div className="font-bold">{finalCartItems.vats ? formatter.format(finalCartItems.vats) : formatter.format(0)} €</div>
            </div>
            <div className="px-1.5 lg:px-3 space-y-2 md:space-y-3">
                <h1 className="capitalize font-semibold text-light-400">{ t('total amount')}</h1>
                <div className="font-bold">{finalCartItems.totalAmount ? formatter.format(finalCartItems.totalAmount) : formatter.format(0)} €</div>
            </div>
        </div> 
    )
}

export default VirtualCartBox;